import { getDisplayOptionForValue } from 'AppSrc/core/components/forms/data/display-option-lookup-utils';
import {
  MOBILE,
  FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const STATUS_REASON_DISPLAY_OPTION_KEY = 'status_reason';

const MOBILE_NO_LONGER_REQUIRED_ID = 'No Longer Required';
const FIXED_NO_LONGER_REQUIRED_ID = '1000';
const FIXED_TO_BE_RESCHEDULE = '2000';
const MOBILE_TO_BE_RESCHEDULE = 'To Be Re-Scheduled';


// Cancel CRQ
// the status reasons list for canceling a CRQ should be a subset of
// the status_reason values in the display_options json.
// The values for mobile correspond to the list but the values for fixed don't
// as such we hard code the fixed values for now


// subset of status reason ids to use as the cancelation reason dropdown list
const mobileCancelationReasonIds = [
  MOBILE_NO_LONGER_REQUIRED_ID,
  'Funding Not Available',
  // 'To Be Re-Scheduled',
  'Resources Not Available',
  '3rd Party',
  'Conflict',
  'Not Approved in time',
  'Superceded by another change',
  'User Error',
  'Customer request',
  'Ongoing fault',
  'Tool issue',
  'Not Attempted',
  // 'Telefonica Cancelled',
  'Opco Cancelled',
  'UK Mobile Cancelled',
  // 'CRQ has been rejected. No further action required until the Co-ordinator updates the CRQ and send back for review/approval',
];

const mobileStatusReasonKey = `${STATUS_REASON_DISPLAY_OPTION_KEY}-${MOBILE}`;

const mobileCancelationReasonOptions = mobileCancelationReasonIds.map(
  (id) => getDisplayOptionForValue(mobileStatusReasonKey, id),
);

// for fixed we need to use hard coded values for now, as the list of options
// requested is inconsistent with dropdowns.json.
// TODO Rectify this in VTO-509
// https://ocasta.atlassian.net/browse/VTO-509
const fixedCancelationReasonOptions = [
  // the following three values are inconsistent with dropdowns.json
  {
    text: 'No Longer Required',
    value: FIXED_NO_LONGER_REQUIRED_ID,
  },
  // {
  //   text: 'To Be Re-Scheduled',
  //   value: '2000',
  // },
  {
    text: 'Duplicate Ticket',
    value: '3000',
  },
  // the rest of the values are consistent and should be referenced from display_options
  // once the fixed numeric values are in place. This should be done as part of VTO-509
  {
    text: 'Rejected - Insufficient Task Data',
    value: '3500',
  },
  {
    text: 'Rejected - Insufficient Change Data',
    value: '3520',
  },
  {
    text: 'Rejected - Schedule Conflict',
    value: '3540',
  },
  {
    text: 'Rejected - Insufficient Notification',
    value: '3560',
  },
  {
    text: 'Cancelled C&WW MI/Network issue',
    value: '4000',
  },
  {
    text: 'Cancelled Customer MI/Network Issue',
    value: '4100',
  },
  {
    text: 'Customer Requested',
    value: '4110',
  },
  {
    text: 'OLO Cancelled',
    value: '4120',
  },
  {
    text: 'Resources - 3rd Party Non Attendance',
    value: '4130',
  },
  {
    text: 'Resources - 3rd Party not available',
    value: '4140',
  },
  {
    text: 'Resources - Engineer Non Attendance',
    value: '4150',
  },
  {
    text: 'Resources - Engineer not available',
    value: '4160',
  },
  {
    text: 'Resources - No Spares',
    value: '4170',
  },
  {
    text: 'VINE Cancelled',
    value: '4200',
  },
  // {
  //   text: 'VINE Stopped',
  //   value: '4210',
  // },
  // {
  //   text: 'VINE Rejected',
  //   value: '4220',
  // },
  {
    text: 'CRQ has been rejected. No further action required until the Co-ordinator updates the CRQ and send back for review/approval',
    value: '28000',
  },
];

const optionsForNetwork = {
  [MOBILE]: mobileCancelationReasonOptions,
  [FIXED]: fixedCancelationReasonOptions,
};

const defaultCancelationReasonForNetwork = {
  [MOBILE]: MOBILE_NO_LONGER_REQUIRED_ID,
  [FIXED]: FIXED_NO_LONGER_REQUIRED_ID,
};

const defaultCancelationReasonForNetworkEmergecy = {
  [MOBILE]: MOBILE_TO_BE_RESCHEDULE,
  [FIXED]: FIXED_TO_BE_RESCHEDULE,
};

const getCancelationReasonDisplayOptions = (network) => optionsForNetwork[network];

const getCancelationReasonText = (network, reasonId) => {

  const options = getCancelationReasonDisplayOptions(network);
  const reasonIdAsString = `${reasonId}`;
  const selectedOption = options ? options.find((option) => option.value === reasonIdAsString) : null;
  return selectedOption ? selectedOption.text : null;
};

const getDefaultCancelationReason = (network) => defaultCancelationReasonForNetwork[network];

const getDefaultCancelationReasonEmergency = (network) => defaultCancelationReasonForNetworkEmergecy[network];

const SUCCESSFUL_STATUS_REASON = {
  text: 'Successful',
  value: '5000',
};
const UNSUCCESSFUL_STATUS_REASON = {
  text: 'Unsuccessful',
  value: '6200',
};
const statusReasonArray = [
  SUCCESSFUL_STATUS_REASON,
  UNSUCCESSFUL_STATUS_REASON,
];
// const getStatusReasonForValue = (statusReasonValue) => statusReasonArray.find((elem) => elem.value === statusReasonValue);
// method to get the correct status reason value for an api status reason paramter
// depending on network. For fixed the parameter represents the value
// otherwise it represents the text
const getStatusReasonTextParameter = (statusReasonValue, network) => {
  if (!statusReasonValue || !network) { return null; }

  const statusReason = statusReasonArray.find((elem) => {
    const parameterMatch = network === MOBILE ? elem.text : elem.value;
    return statusReasonValue === parameterMatch;
  });


  if (!statusReason) {
    console.warn('No status found for statusReasonValue', statusReasonValue);
    return null;
  }
  // we use status text internally
  return statusReason.text;
};

const isUnsuccessfulStatusReason = (value, network) => {
  const statusReasonText = getStatusReasonTextParameter(value, network);
  if (statusReasonText) {
    return statusReasonText === UNSUCCESSFUL_STATUS_REASON.text;
  }
  return false;
};
/*
  DVB 15/07/2020: The following functionality has been deprecated as TIL will automatically change the status reason
  when a rejection workItem is created. However I am leaving the code commented in case we need this requirement changes
  // REJECT crq status reason
  // The server also uses this value to filter on an populate the peer rejection tab on the dashboard
  const REJECT_CRQ_STAUS_REASON = {
    [MOBILE]: 'Peer Rejected',
    [FIXED]: '30100',
  };

  const getRejectedReason = (network) => REJECT_CRQ_STAUS_REASON[network];
*/

export {
  getCancelationReasonDisplayOptions,
  getCancelationReasonText,
  getDefaultCancelationReason,
  getDefaultCancelationReasonEmergency,
  getStatusReasonTextParameter,
  isUnsuccessfulStatusReason,
};
